export default __webpack_public_path__ + "static/media/800.c3eadb0a.png";